import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalCacheReport from '../components/cache/GlobalCacheReport';

const SaasAdminPanel = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  
  // Verificar autenticação ao carregar a página
  useEffect(() => {
    const token = localStorage.getItem('saasAdminToken');
    if (token === 'saas_admin_token_123') {
      setIsAuthenticated(true);
    }
  }, []);
  
  // Função para fazer login
  const handleLogin = (e) => {
    e.preventDefault();
    
    // Senha fixa para super admin (em um app real, seria um processo mais seguro)
    if (password === 'saas_admin_123') {
      localStorage.setItem('saasAdminToken', 'saas_admin_token_123');
      setIsAuthenticated(true);
      setErrorMessage('');
    } else {
      setErrorMessage('Senha incorreta. Tente novamente.');
    }
  };
  
  // Função para fazer logout
  const handleLogout = () => {
    localStorage.removeItem('saasAdminToken');
    setIsAuthenticated(false);
  };
  
  // Se não estiver autenticado, mostrar tela de login
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
          <h1 className="text-2xl font-bold text-center text-indigo-700 mb-6">
            Painel de Administração SaaS
          </h1>
          
          <form onSubmit={handleLogin} className="space-y-4">
            {errorMessage && (
              <div className="bg-red-50 text-red-700 p-3 rounded border border-red-200">
                {errorMessage}
              </div>
            )}
            
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                Senha de Administrador
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
                required
              />
            </div>
            
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition duration-200"
            >
              Acessar
            </button>
          </form>
        </div>
      </div>
    );
  }
  
  // Se estiver autenticado, mostrar o painel
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-indigo-700 text-white shadow">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold">Painel de Administração SaaS</h1>
          
          <div className="flex items-center space-x-4">
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-indigo-800 rounded hover:bg-indigo-900 transition duration-200"
            >
              Sair
            </button>
          </div>
        </div>
      </header>
      
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8 flex justify-between items-center">
          <h2 className="text-xl font-bold">Dashboard Global de Cache</h2>
          
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition duration-200"
          >
            Voltar para Home
          </button>
        </div>
        
        {/* Dashboard Global de Cache */}
        <GlobalCacheReport isSaasAdmin={true} />
        
        {/* Informações do SaaS */}
        <div className="mt-8 bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-bold mb-4">Informações do SaaS</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-purple-50 p-4 rounded-lg border border-purple-100">
              <div className="text-sm text-purple-600">Total de Salões</div>
              <div className="text-2xl font-bold text-purple-700">48</div>
              <div className="text-xs text-purple-500 mt-1">+5 nos últimos 30 dias</div>
            </div>
            
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
              <div className="text-sm text-blue-600">Usuários Ativos</div>
              <div className="text-2xl font-bold text-blue-700">1,245</div>
              <div className="text-xs text-blue-500 mt-1">+12% em relação ao mês anterior</div>
            </div>
            
            <div className="bg-green-50 p-4 rounded-lg border border-green-100">
              <div className="text-sm text-green-600">Agendamentos Realizados</div>
              <div className="text-2xl font-bold text-green-700">8,732</div>
              <div className="text-xs text-green-500 mt-1">+8% em relação ao mês anterior</div>
            </div>
          </div>
          
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500">
              Para dados mais detalhados, acesse o dashboard completo de análise de negócios.
            </p>
          </div>
        </div>
      </main>
      
      <footer className="bg-gray-800 text-white py-4">
        <div className="container mx-auto px-4 text-center">
          <p>Sistema de Monitoramento de Cache - v1.0</p>
          <p className="text-sm text-gray-400 mt-1">
            © 2023 Todos os direitos reservados
          </p>
        </div>
      </footer>
    </div>
  );
};

export default SaasAdminPanel; 